export function BranchesDashboardCtrl (
  $scope,
  businessIntelligenceDashboards,
  inheritorApi,
  linkedCompanies,
  stats
) {
  $scope.businessIntelligenceDashboards = businessIntelligenceDashboards;
  $scope.linkedCompanies                = linkedCompanies;
  $scope.stats                          = stats;

  inheritorApi.inheritCtrl('BranchesDashboardLiteCtrl', $scope);
}